import React, { useEffect, useState, useRef, VFC, ChangeEvent, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import './editInstitute.scss';
import AddWhiteIcon from '@/assets/steam/add-white.png';
import CloseIcon from '@/assets/steam/close.svg'
import { showNotification } from '@/utils/notificationUtils';
import DatePicker, { DayValue, DayRange, Day } from 'react-modern-calendar-datepicker';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import moment from 'moment';
import { useAuth } from '@/lib/auth';
import Utils from '@/utils/util';
import { User } from '@/types';
import 'react-phone-input-2/lib/style.css'; // You may need to import the stylesheet as well
import PhoneInput from 'react-phone-input-2';
import { default as ReactSelect, components } from 'react-select';
import { PageHeader } from '@/components/PageHeaders/PageHeader';
import { City, Institute, State } from '../types/indes';
import Dropdown from 'react-bootstrap/Dropdown';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { useUpdateInstitute } from '../api/updateInstitute';
import { ModalFooter } from 'react-bootstrap';
import { SelectedManagers } from '@/features/users/components/SelectedManagers';

const EditInstitute: VFC<{
    onConfirm: () => void;
    onClose: () => void;
    open: boolean;
    states?: any;
    role?: any;
    editInstituteData?: any;
    instituteList?:any
}> = ({ onClose, onConfirm, open, states, role, editInstituteData,instituteList }) => {
    const { user } = useAuth();
    const [phone, setPhone] = useState('');
    const [cityData, setNewCityData] = useState<string>('');
    const useInstituteUpdateMutations = useUpdateInstitute();
    const [newCityDetails, setNewCityDetails] = useState<any[]>([]);
    const [deletedCity, setDeletedCity] = useState<any[]>([]);
    const [instituteData, setInstituteData] = useState<Institute>({
        name: '',
        address: '',
        gstNumber:'',
    } as Institute);

    useEffect(() => {
        if (editInstituteData) {

            setInstituteData({
                name: editInstituteData?.name,
                address: editInstituteData?.address,
                gstNumber: editInstituteData?.gstNumber
            } as Institute)

            setPhone(editInstituteData?.phone)

        }

    }, [editInstituteData])


    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.id === 'name') {
            instituteData.name = event.target.value;
        } else if (event.target.id === 'address') {
            instituteData.address = event.target.value;
        }
        else if (event.target.id === 'gstNumber') {
            instituteData.gstNumber = event.target.value;
        }
        setInstituteData({ ...instituteData });
    };


    const resetStates = () => {
        setPhone('')

    }

    const removeProvider = (provider: any) => {
        
    };
    const getContent = () => {
        return (
            <div className="add-location-content">
                <div className="user-container">
                    <h1>
                        Institue <span>*</span>
                    </h1>
                    <div className='user-first-last-div'>
                        <input
                            className={`custome-input`}
                            placeholder={'Institute name'}
                            onChange={handleChange}
                            value={instituteData?.name}
                            id="name"
                        />
                    </div>
                
                    <div className='user-first-last-div'>
                        <input
                            className={`custome-input`}
                            placeholder={'Institute address'}
                            onChange={handleChange}
                            value={instituteData?.address}
                            id="address"
                        />
                    </div>

                </div>
                <div className='divider'></div>
                <div className="user-container">
                    <h1>
                        Location Details <span>*</span>
                    </h1>
                    <div className='user-first-last-div'>
                        <input
                            className={`custome-input width-50`}
                            placeholder={'Name'}
                            onChange={handleChange}
                            value={editInstituteData?.state?.name}
                            disabled={true}
                        />
                        <input
                            className={`custome-input width-50`}
                            placeholder={'Name'}
                            onChange={handleChange}
                            value={editInstituteData?.city?.name}
                            id="name"
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="user-container">
                    <h1>
                        GST No <span></span>
                    </h1>
                    <div className='user-first-last-div'>
                        <input
                            className={`custome-input`}
                            placeholder={'Enter GST Number'}
                            onChange={handleChange}
                            value={instituteData?.gstNumber}
                            id="gstNumber"
                        />
                    </div>
                    </div>
                <div className='divider'></div>
                <div className="user-container">

                <h1 className='mb-3'>
                        Contact Details <span>*</span>
                    </h1>
                    <SelectedManagers
                        removeProvider={removeProvider}
                        selectedServiceProviders={editInstituteData?.contacts}
                        showDeleteOption={false}
                        isShowPhone={true}
                        showInstName={true}
                    />
                </div>

            </div>
        );
    };
    return (
        <>
            <Modal
                show={open}
                onHide={() => { resetStates(), onClose() }}
                className={`steam-modal-dialog add-contact-modal `}
                size="sm"

            >
                <Modal.Header closeButton >
                    <div className="model-header-tab">
                        <div className="modal-header-title">
                            {editInstituteData ? "Edit Institute" : 'Add new institute'}
                        </div>
                        <div className="modal-header-desc">
                            {/* {'Lorem ipsum dolor sit amet, consectetur elit, sed'} */}
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body >{getContent()}</Modal.Body>
                <ModalFooter>
                    <div className={`btn-container end`}>
                        <button
                            className={`steam-button button-dark set-height`}
                            onClick={async () => {
                                await useInstituteUpdateMutations.mutateAsync({
                                    id: editInstituteData ? Number(editInstituteData?.id) : undefined,
                                    name: instituteData?.name,
                                    address: instituteData?.address,
                                    gstNumber: instituteData?.gstNumber
                                });
                                onConfirm();

                            }}
                        //disabled={useAddInstituteMutation?.isLoading}
                        >
                            <span>{editInstituteData ? "Save" : 'Add User'}</span>
                        </button>
                    </div>
                </ModalFooter>
            </Modal>
        </>
    );
};




export default EditInstitute;
